import { render, staticRenderFns } from "./OperaBaseParamWindow.vue?vue&type=template&id=c06028b2&"
import script from "./OperaBaseParamWindow.vue?vue&type=script&lang=js&"
export * from "./OperaBaseParamWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports